import React from 'react';
import { Container, Paper, Typography, Box, Button } from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { getCurrentOrganization } from '../utils/organizationContext';

const FoundationSchoolSuccess = () => {
  const navigate = useNavigate();
  const { organizationSlug: urlSlug } = useParams();
  const { organizationSlug } = useAuth();
  
  // Get organization slug from URL or context
  const currentOrgSlug = urlSlug || organizationSlug || getCurrentOrganization();
  
  const handleReturnHome = () => {
    // Always try to go back to the foundation school form for the current organization
    if (currentOrgSlug) {
      navigate(`/${currentOrgSlug}/foundation-school`, { replace: true });
    } else {
      // Fallback: go to welcome page
      navigate('/', { replace: true });
    }
  };

  return (
    <Container maxWidth="md" sx={{ py: 8 }}>
      <Paper elevation={3} sx={{ p: 6, textAlign: 'center' }}>
        <Typography variant="h4" gutterBottom color="primary">
          Enrollment Successful!
        </Typography>
        
        <Typography variant="h6" sx={{ mb: 4 }}>
          Thank you for enrolling in Foundation School.
        </Typography>

        <Typography variant="body1" sx={{ mb: 3 }}>
          Your enrollment has been received successfully. Our team will be in touch with you soon regarding your Foundation School classes.
        </Typography>

        <Typography variant="body1" sx={{ mb: 4 }}>
          "Study to shew thyself approved unto God, a workman that needeth not to be ashamed, rightly dividing the word of truth." - 2 Timothy 2:15 (KJV)
        </Typography>

        <Box sx={{ mt: 4 }}>
          <Button
            variant="contained"
            color="primary"
            onClick={handleReturnHome}
          >
            Submit Another Enrollment
          </Button>
        </Box>
      </Paper>
    </Container>
  );
};

export default FoundationSchoolSuccess;





